import { MaterialDto } from '@app/generated/model';

export class WorkOrderMaterial {
  materialId: string;
  description: string;
  materialNumber: string;
  quantity: number;
  inStock: boolean;
  unit: string;
  materialStatus: string;
  locationNo: string;
  locationName: string;

  constructor(init: Partial<WorkOrderMaterial>) {
    Object.assign(this, init);
  }

  static fromDto(dto: MaterialDto): WorkOrderMaterial {
    return new WorkOrderMaterial({
      materialId: dto.id,
      materialNumber: dto.materialNumber,
      description: dto.description,
      quantity: dto.quantity,
      inStock: dto.inStock,
      unit: dto.unit,
      materialStatus:
        dto.availabilityStatusCode && dto.availabilityStatusText
          ? `${dto.availabilityStatusCode} - ${dto.availabilityStatusText}`
          : (dto.availabilityStatusCode ?? dto.availabilityStatusText ?? ''),
      locationNo: dto.locationNo,
      locationName: dto.locationName,
    });
  }
}
